module.exports = __webpack_public_path__ + "static/img/img5.9f79362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img5.png
// module id = h3WD
// module chunks = 1